let wordcloud_dict = {
  0: "全職工作",
  1: "兼職工作",
  2: "自僱人士",
  3: "社會企業",
  4: "有酬職業/見習訓練",
  5: "Freelance",
  6: "職業探訪",
  7: "影子工作",
  8: "無酬工作見習",
  9: "學徒培訓",
  10: "服務中心探訪",
  11: "賣旗",
  12: "社區送暖活動",
  13: "其他義務工作",
  14: "義遊團",
  15: "自家手作",
  16: "家務工作",
  17: "鄰舍照顧",
  18: "體育活動",
  19: "文化活動",
  20: "電子/網上文化研究",
  21: "歷史保育活動",
  22: "環境保護活動",
  23: "人權倡議活動",
  24: "動物權益活動",
  25: "其他專注的興趣"
};

export default wordcloud_dict;


// WEBPACK FOOTER //
// ./src/assets/wordcloud-dict.js